import React from 'react';
import Icons from "./Icons";

export default class Activities extends React.Component {

	render() {
		return (
			<div className='content'>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} February 2025 Ranger Rally</h2>
					<p>
						The <a href="https://photos.app.goo.gl/1Few3YikBtwUWnfy7">February 2025 Ranger Rally</a> was
						held one week later than planned on Saturday, February 22 at 9am at <a
						href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle
						Fields Regional Park</a> in Bluffdale. The original date was
						canceled due to snow and rain. We had six members attend. The field
						was wet due to recent snow melt. The temperatures were normal for
						February but the sun was out and the wind was calm for a while. We
						had a great time flying and talking. Once the breeze picked up it
						got a bit chilly.
					</p>

					<div className='hbox-wrappable'>
						<figure>
							<a href='https://photos.app.goo.gl/GRDLvkdTjL3ZCpQ57'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/AP1GczPGbLXKh280qHt43vZpWK09tHWva4XIjK9aAWcgUI7EkSXMZNvB4MHEXAFPZnTJWfUzH4jFVSlXRTLExmWlC4KgUK5dLJTOiqVtvf7XVTLkIk1nKHlTYISLR2IweFB03R9ff0XX5JGjZ1D7PcnZzSvL=w1200-h800-s-no-gm'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>Micah's E-flight Commander positioned against the hills</figcaption>
						</figure>

						<figure>
							<a href='https://photos.app.goo.gl/nrL2TU6o391ya4M6A'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/AP1GczN25atdvVheAL8hvstCScvvJlQV2xGHp8By8CHdab2bdWG74qMvmRkH5JLf5XlVUGI6AennOFPgEn8MXoD4FexvTUs_vSzJ7fkbXLLf3aEnafWZ1wQrCywO1vfN8FGToUe5gYCCN8wiF5cve6pxg45V=w1200-h800-s-no-gm'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>Noah launching his twin-motor flying wing</figcaption>
						</figure>
					</div>
				</div>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} October 2024 Ranger Rally</h2>
					<p>
					</p>
				</div>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} August 2024 Ranger Rally</h2>
					<p>
						The August 2024 Ranger Rally was held Saturday, Aug 17 at 9am at <a
						href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle
						Fields Regional Park</a> in Bluffdale. We had six members attend. We
						surprised when we arrived to see the sprinklers running on the field.
						Some of us risked flying, no knowing where we would land. We also
						knew there was a risk of thunderstorms later that morning. We did
						our best to fly anyway. Around 11:30am we stopped the rally due to
						incoming weather and received heavy rain just as we finished packing
						up. It was an exciting morning dodging sprinklers and storms.
					</p>
				</div>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} May 2024 Ranger Rally</h2>
					<p>
						The <a href='https://photos.app.goo.gl/MueRuErjTpaApBMaA'>May 2024 Ranger Rally</a> was
						held Saturday, May 18 at 9am at <a
						href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle Fields Regional Park</a> in
						Bluffdale. We had eight members attend, and four guests.
						The weather was perfect for flying. Light winds, clear skies and
						warm temperatures. We had as many as five aircraft in the air at
						the same time. There was one mid-air collision. One aircraft
						survived the incident, the other did not.
					</p>
					<div className='hbox-wrappable'>
						<figure>
							<a href='https://photos.app.goo.gl/LCfVMsccgc3f6bbV7'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/AP1GczMVEjTTGTbgc0OWsPjQBg4jlzvX3DtUdXEGQk-1GC9ZDJi7jpqWouLK71dOwEV7yBFf81VCO9P76P_fHELvat71zXJyNSuXNjcjxfz57pAXy-NjRlRwMYYX7xF2kcOoAKVFvXawaUj0etX4KvDYd8vE=w3530-h1986-s-no-gm'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>What's that up in the sky?</figcaption>
						</figure>

						<figure>
							<a href='https://photos.app.goo.gl/aXgcHwqa6kZQhMJe6'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/AP1GczPA0gr8rR9_PDUrcoVND73Jq_32ErNFUdL4kn98oLaL49dnR4gJFLzQqyOqIUa2LduicsCk9m46IfQtmvp857SI5CUttTSLs68xVF2dK3GW5lUAovG-BewTYMb147MbyZykQvIQvxcUiamk2LGyn8eQ=w3530-h1986-s-no-gm'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>A busy flight line</figcaption>
						</figure>
					</div>
				</div>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} February 2024 Ranger Rally</h2>
					<p>
						The February 2024 Ranger Rally was held Saturday, February 17 at 9am at <a
						href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle Fields Regional Park</a> in
						Bluffdale. We had five members attend. The field was wet due to recent
						snow melt. The temperatures were normal for February but the sun was
						out and the wind was calm. We had a great time flying and talking.
						We had a few new members join us for the first time.
					</p>
				</div>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} October 2023 Ranger Rally</h2>
					<p>
						The <a href='https://photos.app.goo.gl/BrDLrqYSPC11K79L7'>October 2023 Ranger Rally</a> was
						held Saturday, October 21 at 9am at <a
						href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle Fields Regional Park</a> in
						Bluffdale. We had nine members attend. The field was recently cut
						allowing for some nice rolling departures for those who had landing
						gear. It was a bit breezy in the morning, combined with partly
						cloudy skies is was a bit chilly for the first hour or so. Whenever
						there was sunshine we all breathed a sigh of relief. Steve was our
						photographer of the day and captured some great photos.
					</p>

					<div className='hbox-wrappable'>
						<figure>
							<a href='https://photos.app.goo.gl/4pLGvZZQJc7y6ENo7'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/ADCreHfFyXSpEBy6Ewzqm35syYfLuj5yic_jBEzTU1zKkQ-_JQPz9owUO6LInEaep4dv5W-YyuRZ2wfeD8SlBuEnIpkRwhRSYqWr6nMV6bU8C9nVY7TJdx9PXG_-Ac8cj6WQjm9xjvXW_2J9SAYkjquPWBNoLw=w2342-h1764-s-no-gm'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>Let the flying begin!</figcaption>
						</figure>

						<figure>
							<a href='https://photos.app.goo.gl/NM8AGVaKMW6xMSuy5'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/ADCreHdYd9ELnoFPQoLHwdEkH0coByv5y6yx6fYWKSi-TJImOsNg8Fah493slOMRlPEu96snbv9v90_71ls_aPyf925vJU6vjsQiKYwC0VkhhHK6ZAHtmLvA_7yUIo1X2RSa8f7GeDdE5vzdrv4TAhF0NYzlYQ=w2342-h1764-s-no-gm'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>Joe preparing his E-flite Habu "vacuum cleaner"</figcaption>
						</figure>

						<figure>
							<a href='https://photos.app.goo.gl/mHTXqG8p56Q4zcju7'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/ADCreHclBEWhENukJLDAe-BeTGq5oPgfzZwY1YLSoZcrpf3XGxr-4xJIVkTJViPpBKL99HyRNlOHZKGsEfs-N5HPONKQMz0HillyEB7y5rK_RqTf3cDMHJ46k2lq8Lm4TjiYZwE9zRs5MLo-thUOK5ppd1y_4A=w2342-h1764-s-no-gm'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>Glen preparing 'Rosa' for a flight. Check out that battery!</figcaption>
						</figure>
					</div>
				</div>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} August 2023 Ranger Rally</h2>
					<p>
						The <a href='https://photos.app.goo.gl/JyAom3wzCLAFVQrw9'>August 2023 Ranger Rally</a> was
						held Saturday, August 19 at 9am at <a
						href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle Fields Regional Park</a> in
						Bluffdale. We had eight members attend. The field was moist from
						recent rain and the grass was thick and green. The temperatures were
						unseasonably cool for August and we had cloud cover the entire time.
						The wind was brisk from the south but died down a bit about half way
						through the rally.
					</p>

					<div className='hbox-wrappable'>
						<figure>
							<a href='https://photos.app.goo.gl/g4KubKDW8pzLTTEs7'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/ADCreHe9Tl1UvqqouGhpoRLp4GBdyUwOSwd7CWXVg-kPIo7TdvqZqVOQL3WglUvnJwFMBCNpQxAi4yzqMOXCDsu57VsN4ebFzLMCFqLyeO1rbQk-vGPUd6wJdFPIGJW8xOcxD91FzhnmyZ29oZjCD2144XZU_w=w2577-h1941-s-no'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>The flight line</figcaption>
						</figure>

						<figure>
							<a href='https://photos.app.goo.gl/1VkXjrRtDDzRyM3p7'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/ADCreHf3Aljgl5R3AyVs5BsBfg6A_lYyNnyinNdnD-cBRdXm_6l0YoFESyTRfx9gPvm9t9-WihNKUcuAYCGSbJ6paYEDv8u-u9YIeFKJ9HCl4mmqrb0lbnTzlXiEXtB7urr54wh_x_zdwalDHATLC15upF_D=w1200-h800-s-no'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>Yep, it really can do that</figcaption>
						</figure>
					</div>

				</div>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} May 2023 Ranger Rally</h2>
					<p>
						The <a href='https://photos.app.goo.gl/vuabzgKsuvk5vg9G9'>May 2023 Ranger Rally</a> was
						held Saturday, May 20 at 9am at <a
						href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle Fields Regional Park</a> in
						Bluffdale. We had eight members attend.
					</p>
				</div>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} February 2023 Ranger Rally</h2>
					<p>
						The <a href='https://photos.app.goo.gl/H8n5bWr7nuzC3G4h9'>February 2023 Ranger Rally</a> was
						held Saturday, February 18 at 10am at <a
						href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle Fields Regional Park</a> in
						Bluffdale. We had six members attend. The field was dry and the sun
						was out which made for pretty good flying until the breeze picked up
						about half way through that made it pretty chilly. A lot of good
						discussion about <a href="https://www.expresslrs.org/">ELRS</a> and
						supported hardware as well as a bunch of flying.
					</p>

					<div className='hbox-wrappable'>
						<figure>
							<a href='https://photos.app.goo.gl/KRT4Qb8o1B1jKSd77'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/AMWts8CRrfUHypiySsicUiN2LyHJ1CQZBuubRcCXWKuS9z5op8CrckxsiPjN4wWGdUi6qSKk8Q3MdY4dAYJxGI22NrOV6xM1X7J65xHMSa2dN3zJ4WO5oiKXBq29KB0MmigT3K5-G9dKPz-qvQJy8BPtFijq=w1200-h800-no'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>From the left, Steve, Blaine, Matt, Glen and Mark.</figcaption>
						</figure>

						<figure>
							<a href='https://photos.app.goo.gl/mPNT4puoGXK2cwKo6'>
								<img className='photo'
										 src='https://lh3.googleusercontent.com/pw/AMWts8BxQ9Uvi8UFWM5NxstmTAf5UTtUqjSipPzHp7xSeE8b_wlmjG6Pau-15TNKsvSW6JlODjiyw9I57oV991PtSQMoVQ_9HIDZsIcwtutUI-ZBDQ9-Xmalt-1VZi3QovQm7PdcqyjrYDrmozjzU5cSPAvW=w1200-h800-no'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>The elegant wings of Glen's Bixler II</figcaption>
						</figure>
					</div>
				</div>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} October 2022 Ranger Rally</h2>
					<p>
						The <a href='https://photos.app.goo.gl/Z3bZu5KKpnuC4vAx9'>October 2022 Ranger Rally</a> was
						held Saturday, October 15 at 9am at <a
						href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle Fields Regional Park</a> in
						Bluffdale. We had most of the club members as well as some new
						flyers and spectators. The morning hours were breezy which may
						flying light airplanes a bit tricky. After noon the breeze settled
						down and it felt more comfortable so several of us stays another
						couple of hours to keep flying. Noah won the spot landing challenge
						with a distance of just 13 feet. Well done Noah! We greatly
						appreciate our photographer Steve.
					</p>

					<div className='hbox-wrappable'>
						<figure>
							<a href='https://photos.app.goo.gl/Pk4LwoPbhzXnbdgT7'>
								<img className='photo' src='/photos/2022-10-15-ranger-rally.jpg'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>From the left, Logan, Glen, John, Mark, Steve, Matt, Lionel, Skye, Noah and
								Hudson.
							</figcaption>
						</figure>

						<figure>
							<a href='https://photos.app.goo.gl/Pk4LwoPbhzXnbdgT7'>
								<img className='photo' src='/photos/2022-10-15-ranger-rally-p40.jpg'
										 alt='DSR Ranger Rally P-40'/>
							</a>
							<figcaption>Steve trying out his new P-40</figcaption>
						</figure>
					</div>

				</div>

				<div className='announcement'>
					<h2>{Icons.DESERT_SKY_RANGERS} August 2022 Ranger Rally</h2>
					<p>
						The <a href='https://photos.app.goo.gl/1i374x5e5sQRXYBcA'>August 2022 Ranger Rally</a> was held
						Saturday, August
						13 at 9am at <a href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle Fields
						Regional Park</a> in
						Bluffdale. We were fortunate that all members of the club were able
						to attend. We spent several hours together flying, chatting, and
						flying some more. We got some updated club pictures, showed off some
						new aircraft builds. Some of the most fun was doing one of the
						scheduled challenges. Blaine won the gliding challenge by staying
						aloft for 102 seconds with only 15 seconds of climb power. Well done
						Blane! Noah finally got to fly his twin engine flying wing. Hudson
						few his rescue plane Charmane. She unfortunately ended up with a
						broken tail feather. We greatly appreciate our photographers Steve
						and John-Erik. Without them there would have been fewer moments to
						remember.
					</p>
					<div className='hbox-wrappable'>
						<figure>
							<a href='https://photos.app.goo.gl/aVd5UBe7TvWuFLZQA'>
								<img className='photo' src='/photos/dsr-club-2022-08-13.jpg' alt='DSR Ranger Rally'/>
							</a>
							<figcaption>From the left, Steve, Micah, Mark, Noah, Hudson, Glen and Blaine.</figcaption>
						</figure>
						<figure>
							<a href='https://photos.app.goo.gl/Hb6kbQBNApaLCwfY6'>
								<img className='photo' src='/photos/2022-08-13-ranger-rally-banner.jpg'
										 alt='DSR Ranger Rally'/>
							</a>
							<figcaption>Noah starts the Ranger Rally with a banner flyover.</figcaption>
						</figure>
					</div>
				</div>

				<div className='announcement'>
					<h2>{Icons.RALLY} Jun 2022 Build Day</h2>
					<p>
						On Saturday, Jun 4th we held a <a href='https://photos.app.goo.gl/Sd3FaTet7f8DoNpA6'>build
						day</a> to spend some time building
						several <a href="/plans">DSR-001 aircraft</a>. What started out as a cool breezy day turned
						into a hot breezy day as we worked through taping together plans,
						cutting out parts and using hot glue to assemble aircraft. By the end
						of the day, Noah and Hudson had their first DSR-001 aircraft built.
					</p>
					<div className='hbox-wrappable'>
						<figure>
							<img className='photo' src='/photos/2022-06-04-build-day/ms/0604221612_HDR.jpg'
									 alt='DSR Build Day'/>
							<figcaption>Hudson working on his DSR-001 wing.</figcaption>
						</figure>
						<figure>
							<img className='photo' src='/photos/2022-06-04-build-day/ms/0604221613a_HDR.jpg'
									 alt='DSR Build Day'/>
							<figcaption>Noah working on his DSR-001 wing.</figcaption>
						</figure>
						<figure>
							<img className='photo' src='/photos/2022-06-04-build-day/ms/0604221613b_HDR.jpg'
									 alt='DSR Build Day'/>
							<figcaption>Glen (build supervisor), Noah and Hudson.</figcaption>
						</figure>
					</div>
				</div>

				<div className='announcement'>
					<h2>{Icons.RALLY} Feb 2022 Ranger Rally</h2>
					<p>
						We held the Feb 2022 Ranger Rally on Saturday, Feb 12th
						at <a href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle Fields Regional
						Park</a>.
						This time we chose to fly in the afternoon which turned out to be
						a great choice because the wind calmed down and the temperatures
						came up to give us fantastic flying weather. Micah brought his dad
						out to fly with us along with a beautiful modified Piper Cub.
						Hudson put in several more flights on his Bixler II and had great
						landings. Noah flew his Bixler and Arrow. Unfortunately the Arrow
						had a spectacular nose-in landing so he will be working on a new
						build soon. Glen brought out several new aircraft. His biplane
						struggled to get off the ground due to the long grass, and even
						then, the flights were nothing more than a hop. His Cronos I had
						its maiden flight and after putting in a 4S battery flew nicely.
						Last, but not least, Holden got one launch with his new rocket.
						We're not sure how high it went but we were glad the parachute did
						not fully deploy so it came down nearby. Apparently we were having
						so much fun flying, we didn't get any photos. All in all, a good
						day!
					</p>
				</div>

				<div className='announcement'>
					<h2>{Icons.RALLY} Jan 2022 Ranger Rally</h2>
					<p>
						We held the <a href='https://photos.app.goo.gl/jNU48m2dBRWr3df98'>Jan 2022 Ranger Rally</a> on
						Saturday, Jan 29th
						at <a href="https://goo.gl/maps/WfuVVZqe4Qv32PX27">{Icons.LOCATION} Wardle Fields Regional
						Park</a>.
						It was a cold morning with temperatures just above freezing. Several of us
						got to try out new equipment and aircraft that we received over the
						holidays. Hudson was able to maiden his new Bixler 2. Noah flew his
						rebuilt FliteTest Arrow successfully and we all got a birdseye view from
						Mark's new FPV setup on his Typhoon III. Blaine also joined the fun
						with his Bixler and giant Volantex Ranger 2000.
					</p>
					<div className='hbox-wrappable'>
						<figure>
							<img className='photo' src='/photos/2022-01-29-ranger-rally/2022-01-29-hudson-bixler-1.jpeg'
									 alt='DSR Ranger Rally'/>
							<figcaption>Hudson's new Bixler 2.</figcaption>
						</figure>
						<figure>
							<img className='photo' src='/photos/2022-01-29-ranger-rally/2022-01-29-noah-arrow-1.jpg'
									 alt='DSR Ranger Rally'/>
							<figcaption>Noah preparing his Arrow.</figcaption>
						</figure>
						<figure>
							<img className='photo' src='/photos/2022-01-29-ranger-rally/2022-01-29-mark-typhoon-1.jpg'
									 alt='DSR Ranger Rally'/>
							<figcaption>Mark and Blaine FPV preflight check.</figcaption>
						</figure>
						<figure>
							<img className='photo' src='/photos/2022-01-29-ranger-rally/2022-01-29-mark-typhoon-2.jpg'
									 alt='DSR Ranger Rally'/>
							<figcaption>FPV flyby.</figcaption>
						</figure>
						<figure>
							<img className='photo' src='/photos/2022-01-29-ranger-rally/2022-01-29-blaine-ranger-1.jpg'
									 alt='DSR Ranger Rally'/>
							<figcaption>Blaine's graceful Ranger.</figcaption>
						</figure>
						<figure>
							<img className='photo' src='/photos/2022-01-29-ranger-rally/2022-01-29-mark-bixler-1.jpg'
									 alt='DSR Ranger Rally'/>
							<figcaption>Mark getting in some inverted flight practice.</figcaption>
						</figure>
					</div>
				</div>


				<div className='announcement'>
					<h2>{Icons.RALLY} Nov 2021 Ranger Rally</h2>
					<p>
						We held an <a href='https://photos.app.goo.gl/yTDm9bs3eGu8yDx97'>impromptu Ranger Rally</a> on
						Saturday,
						Nov 20th. For the first time we had all members
						of the club available for a <a href='/about'>group photo</a> and had a chilly morning of
						flying. Despite the cool weather we had a great time getting together, increasing our flight
						times and sharing stories.
					</p>
					<div className='hbox-wrappable'>
						<figure>
							<img className='photo' src='/photos/2021-11-20-ranger-rally/hudson.jpg'
									 alt='DSR Ranger Rally'/>
							<figcaption>Hudson at the controls, Mark and Percy looking on.</figcaption>
						</figure>
					</div>
				</div>

			</div>
		)
	}

}
